<template>
  <div>
    <b-table
      :items="items"
      :fields="fields"
      striped
      hover
      small
      stacked="sm">
      <template #cell(acciones)="row">
        <b-button size="sm" @click="row.toggleDetails">
          {{ row.detailsShowing ? 'Ocultar' : 'Ver' }} Detalles
        </b-button>
      </template>
      <template slot="row-details" slot-scope="row">
        <detalles-tabla :detallerender="detallerender" :objeto="row"></detalles-tabla>
      </template>
      <slot name="table-caption"></slot>
    </b-table>
  </div>
</template>

<script>
import formatters from '@/helpers/formatters'
import DetallesTabla from "../common/TablaBaseDetalle";
export default {
  name: "TablaBase",
  mixins: [formatters],
  props: {
    items: Array,
    fields: Array,
    detallerender: String
  },
  components: {
    DetallesTabla
  },
  data() {
    return {
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        }
    }
  },
  methods: {

  }

};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/TablaBase.vue